import axios from "axios";
import { tryCatchHandlr } from "@shared/Utilities"
import { caseTransformingAxios } from "@shared/v2/caseTransformingAxios";

export const getEnvoyReferralsFormDataApi = async (personId) => {
  const [res, err] = await tryCatchHandlr(axios.get(`/api/v4/contact_people/${personId}/envoy_referrals/form_options`))

  return { res, err }
};

export const postEnvoyReferralApi = async (personId, data) => {
  const [res, err] = await tryCatchHandlr(axios.post(`/api/v4/contact_people/${personId}/envoy_referrals`, data, {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "x-csrf-token": window.ReactOnRails.authenticityToken(),
    }
  }))

  return { res, err }
}

export const getGoogleMapsAutoCompleteApi = async (searchQuery) => {
  const [res, err] = await tryCatchHandlr(caseTransformingAxios.get("/maps/autocomplete", {
    params: { searchQuery, supportedTypes: 'address' },
  }))

  return { res, err }
}

export const getGoogleDetailsByPlaceIdApi = async (placeId) => {
  const [res, err] = await tryCatchHandlr(caseTransformingAxios.get("/maps/details", {
    params: { placeId },
  }))

  return { res, err }
}

export const getStandardizedAddressApi = async (slug) => {

  const [res, err] = await tryCatchHandlr(caseTransformingAxios.get(`/api/v4/person/${slug}/standardized_addresses`));

  return { res, err }
}

export const getSuggestedAddressCheck = async ({ streetAddress, city, locality, postalCode, country }, slug) => {
  const [res, err] = await tryCatchHandlr(caseTransformingAxios.get(`/api/v4/person/${slug}/suggest_standardized_address`, {
    params: {
      streetAddress,
      city,
      locality,
      postalCode,
      country,
    },
  }));

  return { res, err }
}